// @ts-nocheck
/*
 * Port of views/dashboard/voice-plan/VoicePlanMetricModals.js (164 lines).
 * BYTE-IDENTICAL — dialog header + pulse-details + price-details tables.
 */
import React from 'react';
import { FaClock, FaRupeeSign, FaPhoneAlt, FaRoute } from 'react-icons/fa';
import {
  formatDurationLabel,
  formatPriceDisplay,
  flattenPlansToArray,
} from '@/utilities/voicePlanUtils';
import { CallTypeIcon, LegTypeDisplay } from '@/features/voice-plan/voice-plan-shared';

function MetricTableHeader({ icon: Icon, label, iconClass }) {
  return (
    <th>
      <span className="vp-metric-th">
        <span className={`vp-metric-th__icon ${iconClass}`}>
          <Icon size={12} />
        </span>
        <span className="vp-metric-th__label">{label}</span>
      </span>
    </th>
  );
}

export function VoicePlanMetricDialogHeader({ variant, planName }) {
  const isPulse = variant === 'pulse';
  const Icon = isPulse ? FaClock : FaRupeeSign;
  const title = isPulse ? 'Pulse Details' : 'Price Details';

  return (
    <div className="vp-metric-dialog-header">
      <div
        className={`vp-metric-dialog-header__icon ${
          isPulse ? 'vp-metric-dialog-header__icon--pulse' : 'vp-metric-dialog-header__icon--price'
        }`}
      >
        <Icon />
      </div>
      <div className="vp-metric-dialog-header__text">
        <div className="vp-metric-dialog-header__title">{title}</div>
        {planName ? <div className="vp-metric-dialog-header__subtitle">{planName}</div> : null}
      </div>
    </div>
  );
}

export function VoicePlanPulseDetailsContent({ plan }) {
  const legs = flattenPlansToArray(plan?.plans);
  if (!legs.length) return <p className="vp-muted mb-0">No pulse duration data available.</p>;

  return (
    <div className="vp-metric-modal-table-wrap">
      <table className="vp-metric-modal-table">
        <thead>
          <tr>
            <MetricTableHeader icon={FaPhoneAlt} label="Call Type" iconClass="vp-metric-th__icon--call" />
            <MetricTableHeader icon={FaRoute} label="Leg Type" iconClass="vp-metric-th__icon--leg" />
            <MetricTableHeader icon={FaClock} label="Pulse Duration" iconClass="vp-metric-th__icon--pulse" />
          </tr>
        </thead>
        <tbody>
          {legs.map((leg, index) => {
            const type = String(leg.plan_type || '').toUpperCase();
            return (
              <tr key={index}>
                <td>
                  <span className="vp-detail-call-type">
                    <CallTypeIcon type={type} />
                    {type}
                  </span>
                </td>
                <td>
                  <LegTypeDisplay legType={leg.leg_type} />
                </td>
                <td>
                  {type === 'MISSED' ? <span className="vp-muted">N/A</span> : formatDurationLabel(leg.pulse_duration)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export function VoicePlanPriceDetailsContent({ plan }) {
  const legs = flattenPlansToArray(plan?.plans);
  if (!legs.length) return <p className="vp-muted mb-0">No pulse price data available.</p>;

  return (
    <div className="vp-metric-modal-table-wrap">
      <table className="vp-metric-modal-table">
        <thead>
          <tr>
            <MetricTableHeader icon={FaPhoneAlt} label="Call Type" iconClass="vp-metric-th__icon--call" />
            <MetricTableHeader icon={FaRoute} label="Leg Type" iconClass="vp-metric-th__icon--leg" />
            <MetricTableHeader icon={FaRupeeSign} label="Pulse Price (Paisa)" iconClass="vp-metric-th__icon--price" />
          </tr>
        </thead>
        <tbody>
          {legs.map((leg, index) => {
            const type = String(leg.plan_type || '').toUpperCase();
            return (
              <tr key={index}>
                <td>
                  <span className="vp-detail-call-type">
                    <CallTypeIcon type={type} />
                    {type}
                  </span>
                </td>
                <td>
                  <LegTypeDisplay legType={leg.leg_type} />
                </td>
                <td>{formatPriceDisplay(leg.pulse_price)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
